
<div :class="['c-search-cards', previewClass]">
  <div class="c-search-cards__heading">
    <h3 class="c-search-cards__title">
      {{ title }}
    </h3>

    <a
      v-if="!isFetching"
      class="c-search-cards__button o-button -md-secondary -md-small -mobile-only"
      :href="action.url"
    >
      {{ action.label }}
    </a>
  </div>

  <div class="c-search-cards__items">
    <template v-if="isFetching">
      <div
        v-for="index in cardsLimit"
        :key="`placeholder-card-${index}`"
        class="c-search-cards__item"
      >
        <div
          :class="`c-search-cards__avatar-image is-fetching -${cardRadius}`"
        />

        <span class="c-search-cards__label is-fetching" />
      </div>
    </template>

    <template v-else>
      <div
        v-for="(card, index) in slicedCards"
        :key="`card-${index}`"
        class="c-search-cards__item"
      >
        <a
          v-if="card.image_public_id"
          :class="`c-search-cards__avatar -${cardRadius}`"
          :href="card.url"
        >
          <img
            :class="`c-search-cards__avatar-image -${cardRadius}`"
            :alt="`Imagem do avatar de ${card.label}`"
            :src="
              card.image_public_id
                | enjuphotosUrl(enjuphotos.presets.userStore.avatar)
            "
          />
        </a>

        <a class="c-search-cards__label" :href="card.url">
          {{ card.label }}
        </a>
      </div>
    </template>
  </div>

  <a
    v-if="!isFetching"
    class="c-search-cards__button o-button -xs-secondary -xs-small -desktop-only"
    :href="action.url"
  >
    {{ action.label }}
  </a>
</div>
